import type { BriefTemplateContent } from '@fluenceur/types';
import type { TFunction } from 'i18next';
import { formatMinorAmount } from '@/pages/collabs/ugc/ugc-tracking-format';

const RIGHTS_KEY = 'collabs.briefTemplates.sections.usageRights';

/**
 * The rights a UGC brief grants, in a few words: the duration, the channels
 * and, when asked, the share of the payment the ads are paid. A part the brand
 * has not stated yet is left out. Read by the wizard recap.
 */
export const ugcRightsParts = (
  content: Pick<BriefTemplateContent, 'usageRights' | 'compensation'>,
  t: TFunction,
  options: { withAdsShare?: boolean; locale?: string } = {}
): string[] => {
  const { usageRights } = content;
  const ads = usageRights.channels.includes('paid_ads');
  const channels = ads
    ? t(`${RIGHTS_KEY}.ugcChannels.organicAndAds`)
    : usageRights.channels.includes('organic')
      ? t(`${RIGHTS_KEY}.ugcChannels.organic`)
      : null;
  const duration =
    usageRights.durationMonths !== null && usageRights.durationMonths !== undefined
      ? t(`${RIGHTS_KEY}.months`, { count: usageRights.durationMonths })
      : null;
  const share =
    options.withAdsShare && ads
      ? formatMinorAmount(
          usageRights.adsShareCents ?? null,
          content.compensation.fixedPayment?.currency ?? null,
          options.locale ?? 'fr'
        )
      : '';
  return [
    duration,
    channels,
    share ? t('invitations.modal.collab.wizard.send.rightsAdsShare', { amount: share }) : null,
  ].filter((part): part is string => !!part);
};
